// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label[data-v-04657221]{padding:15px 0 15px 0}.font-list-settings[data-v-04657221]{margin-bottom:16px}`, "",{"version":3,"sources":["webpack://./src/components/SettingsFontList.vue"],"names":[],"mappings":"AACA,uBACC,qBAAA,CAGD,qCACC,kBAAA","sourcesContent":["\nlabel {\n\tpadding: 15px 0 15px 0;\n}\n\n.font-list-settings {\n\tmargin-bottom: 16px\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
